import React from 'react';
import { useInView } from 'react-intersection-observer';

const FeatureSection = ({ title, description, children, bgColor = 'bg-white', icon }) => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    return (
        <section className={`py-16 ${bgColor}`} id={title.toLowerCase().replace(/\s+/g, '-')}>
            <div className="container mx-auto px-4">
                <div
                    ref={ref}
                    className={`max-w-3xl mx-auto text-center mb-12 transition-all duration-1000 ease-in-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                        }`}
                >
                    <div className="flex items-center justify-center mb-4">
                        {icon && (
                            <div className="p-3 bg-primary-100 rounded-full mr-3">
                                {icon}
                            </div>
                        )}
                        <h2 className="text-3xl font-bold">{title}</h2>
                    </div>
                    {description && (
                        <p className="text-xl text-gray-600">{description}</p>
                    )}
                </div>

                {children}
            </div>
        </section>
    );
};

export default FeatureSection;